export default "__VITE_ASSET__CkQBNaZp__"